//FUNCIONES
import { expresion_civil } from 'components/Admin/Inicio-Admin/Dashboard_Admin';
//COMPONENTES
import Cargando from 'components/Varios/Cargando';
import { authenticationService } from 'services/authentication.service';
//SCSS
import "./Planificacion_Vacaciones.scss"
//URL
import configData from "../../../../config.json";
//OTROS
import Datepicker from 'components/Varios/Datepicker';
import { Card, CardTitle, CardBody, CardFooter, Container, Row, Col, Table, Input, Alert,Modal ,ModalHeader} from "reactstrap";
import React, { useEffect, useMemo, useState } from 'react'
import axios from 'axios';
import subDays from "date-fns/subDays";
import addDays from "date-fns/addDays";
//TYPES
import { UserData } from 'components/Sidebar/Sidebar_Principal';
import DatosGenerales from 'components/Prueba';
import { formatoFecha, function_capitalize, parseo_mes } from 'components/Admin/Inicio-Admin/Dashboard_Individual_Admin';
import { function_obtener_regimen_segun_id } from 'components/Admin/Inicio-Admin/Card_Descargas';
//Icono megafono
import Megafono from "assets/icons/megafono.png"
import { alertService } from 'components/Varios/alert_service';
import { handle_error } from 'components/DirectivoUnidad/Vacaciones/helper_function';
import moment from 'moment'
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion';
import AlertNew, { TiposAlerta } from 'components/Varios/AlertNew';
import { CompareRangeBetweenDates, FormatoDiaMesAnioFecha, FormatoDiaMesFecha, ObtenerFechaFromIsoFormat, PruebaSolucion, PruebaSolucion2 } from 'functions/DatesFunctions';
import { Calendario_Vacaciones, Historial_Planificacion, Planificacion_Enviar, Respuesta_Planificacion_Usuario, Rows_calendario, ValidacionPlanificacion } from './TypesPlanificacionVacaciones';
import { showAlertHTMLSwal, showAlertSwal } from 'components/Admin/AprobacionesSolicitudes/AprobacionSolicitudesTh';
import Swal from 'sweetalert2';
import AnuncioSVG from "assets/icons/Permisos/Anuncio.svg"

import PLANIFICACION from "../../../../assets/img/PlanificacionVac2025.jpg"
import { ModalBody } from 'react-bootstrap';
import IconCloseModal from 'components/Varios/Modals/IconCloseModal';

import { format } from 'date-fns';

const isWeekday = (date: Date) => {
    const day = date.getDay();
    return day !== 0 && day !== 6;
};




export const function_parse_calendario = (indice: number, capitalize: boolean): Array<string> => {
    const mes: Array<string> = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]
    const color_mes: Array<string> = ["#8FC200", "#44E497", "#44B9FF", "#0073D5", "#3043D5", "#752DFF", "#DD3FDE", "#FF8F95", "#FF8F00", "#FF3400", "#A03400", "#008903"]

    var respuesta: Array<string> = []
    if (capitalize) respuesta.push(mes[indice].toUpperCase())
    else respuesta.push(mes[indice])
    respuesta.push(color_mes[indice])

    return respuesta;


}

export const function_calcular_dias_ordinarios = (fecha_inicio: Date, fecha_hasta: Date) => {
    var fecha_inicial = fecha_inicio
    var diferencia_en_tiempo = fecha_hasta.getTime() - fecha_inicio.getTime();

    // To calculate the no. of days between two dates
    var diferencia_en_dias = diferencia_en_tiempo / (1000 * 3600 * 24);

    var contador_dias_ordinarios = 0;

    for (let index = 0; index < diferencia_en_dias; index++) {
        if (fecha_inicial.getDay() !== 0 && fecha_inicial.getDay() !== 6) contador_dias_ordinarios++;
        fecha_inicial = addDays(fecha_inicial, 1);
    }

    contador_dias_ordinarios++;
    return contador_dias_ordinarios;
}

export const formatoFechaTimeZoneLocal = (fecha: Date): string => {
    return new Date(fecha).toLocaleString("en-GB", {
        timeZone: 'America/Bogota',
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
    })
}

export const parseDatetoFormatSend = (fecha: Date | string): Date => {
    // var fecha_parse: Date = new Date(new Date(fecha).toLocaleString("en-US", {
    //     timeZone: 'America/Bogota',
    //     day: "2-digit",
    //     month: "2-digit",
    //     year: "numeric"
    // }));

    // const fecha_parse = fecha.toLocaleDateString('es-ES', {
    //     day: '2-digit',
    //     month: '2-digit',
    //     year: 'numeric',
    //   });
    

    if(typeof(fecha) === "string"){
        const [anio,mes,dia] = fecha.split("T")[0].split("-");
        const mesIndice = +mes - 1;

        

        const fechaParse = new Date(+anio,mesIndice,+dia,0,0,0)

        

        const nuevaFecha = new Date(PruebaSolucion2(fechaParse))
        return nuevaFecha
    }
    else{
        const nuevaFecha = new Date(PruebaSolucion2(fecha))   
        return nuevaFecha 
    }

    
}



export const ESTADO_PENDIENTE = "P"
export const ESTADO_APROBADO = "AP"
export const ESTADO_RECHAZADO = "RE"
export const ESTADO_APROBACION_PARCIAL = "PA"
export const ESTADO_GUARDADO = "G"
export const ESTADO_NO_HA_PLANIFICADO = "N/A"
export const ESTADO_TIENE_RECHAZADAS = "TR"
export const ESTADO_ENVIADO_TALENTO_HUMANO = "ET"

type ModalInformacion = {
    contenidoModal:any,

}

const PlanificacionVacaciones: React.FC = () => {


    const fechaActual = new Date();
    const anioActual = fechaActual.getFullYear();

    const ERROR_ENVIO_PLANIFICACION_RECHAZADA = "No puede enviar una planificación rechazada, por favor elimine o edite su planificación"
    // const ERROR_NO_ALCANZA_DIAS_MINIMOS = "La cantidad de días planificados es menor al mínimo esperado (Revise el Recordatorio de la parte superior)"
    const ERROR_NO_ALCANZA_DIAS_MINIMOS = "La cantidad de días planificados es menor al mínimo esperado"

    const CANTIDAD_DIAS_DEBE_PLANIFICARSE_POR_RANGO = 5;

    const [calendario_vacaciones, setCalendario_vacaciones] = useState<Array<Calendario_Vacaciones>>([]);
    const [cards_meses, setcards_meses] = useState<Array<HTMLElement>>([])
    const [table_historial_planificacion, settable_historial_planificacion] = useState<HTMLElement>();
    const [mes, setmes] = useState(-1)


    //Modal de como planificar
    const [mostrarModalIndicaciones, setmostrarModalIndicaciones] = useState<ModalInformacion|undefined>(undefined)


    //anio planificacion
    const [anioPlanificacion, setanioPlanificacion] = useState<number>(0)

    //Fechas

    const [fechaCorteSaldo, setfechaCorteSaldo] = useState<string>("")
    const [listadoFechasPeriodo, setlistadoFechasPeriodo] = useState<Date[]>([])


    const [fechadesde, setfechadesde] = useState<Date>()
    const [fechahasta, setfechahasta] = useState<Date>()
    const [fechas_escogidas, setfechas_escogidas] = useState<Array<Date>>([])
    const [fechas_feriados, setfechas_feriados] = useState<Array<Date>>([])
    const [min_fechadesde, setmin_fechadesde] = useState(new Date(new Date().getFullYear() + 1, 0, 1))
    const [max_fechadesde, setmax_fechadesde] = useState(new Date(new Date().getFullYear() + 1, 0, 1))


    const [fechainiciomenorrango, setfechainiciomenorrango] = useState(new Date(anioActual + 1, 11, 26));
    const [fechafinmenorrango, setfechafinomenorrango] = useState(new Date(anioActual + 1, 11, 31));

    //Texto de alerta
    const [recordatoriodiasminimo, setrecordatoriodiasminimo] = useState<string>("")
    //Restricciones
    const [tieneVacaciones, settieneVacaciones] = useState<boolean>(false)
    const [tieneRestriccion, settieneRestriccion] = useState<boolean>(false)
    const [validacionPlanificacion, setvalidacionPlanificacion] = useState<ValidacionPlanificacion>({ puedePlanificar: true })
    //Acciones
    const [puedeEnviarPlanificacion, setpuedeEnviarPlanificacion] = useState(true)
    const [isCardEmpty, setisCardEmpty] = useState(false)

    //Alertas
    const [errorPlanificacion, seterrorPlanificacion] = useState(false);
    const [errorOverlapFecha, seterrorOverlapFecha] = useState(false);
    const [erroresGenerales, seterroresGenerales] = useState<Array<string>>([])
    const [planificaComoDocente, setplanificaComoDocente] = useState<boolean>(false);
    const [showWarningDias, setshowWarningDias] = useState<boolean>(false)


    //dias
    const [diassolicitados, setdiassolicitados] = useState("")
    const [diaspendientes, setdiaspendientes] = useState("") //Texto que aparece en input de saldo o dias disponibles para planificar
    const [diaspendientesnumber, setdiaspendientesnumber] = useState<number>(0) //Valor numerico de de dias disponibles para planificar

    const [diasplanificados, setdiasplanificados] = useState(0);
    const [diasdisponibles, setdiasdisponibles] = useState(44);


    const [minimosdiasposibles, setminimosdiasposibles] = useState<number>(1);
    const [maximodiasposibles, setmaximodiasposibles] = useState(44);
    //Condiciones para mostrar componentes
    const [mostrar_table_historial, setmostrar_table_historial] = useState(false);
    const [disabledButtonPlanificar, setdisabledButtonPlanificar] = useState(true);
    const [mostrarModificar, setmostrarModificar] = useState(false)
    const [loading, setloading] = useState<boolean>(true)
    const [loadingPost, setloadingPost] = useState<boolean>(false)
    const [existeObservacion, setexisteObservacion] = useState<boolean>(false);
    const [estatodoAprobado, setestatodoAprobado] = useState<boolean>(false);
    //Observacion
    const [textoObservacionUsuario, settextoObservacionUsuario] = useState<string>("")
    const [regimentexto, setregimentexto] = useState<string>("")

    //Mensaje alerta
    const [mensajeDiasMinimos, setmensajeDiasMinimos] = useState<string>("")
    //Modificar
    const [valoresModificar, setvaloresModificar] = useState<{ indice_row: number, indice_calendario: number }>({ indice_calendario: -1, indice_row: -1 })
    const [actualizarCalendario, setactualizarCalendario] = useState<boolean>(false)
    //Eliminar
    const [valoresEliminar, setvaloresEliminar] = useState<{ datos_row: Rows_calendario, indice_row: number, indice_calendario: number }>(
        {
            datos_row: { Dias_solicitados: -1, Fechadesde: new Date(), Fechahasta: new Date() },
            indice_calendario: -1,
            indice_row: -1
        })

    const [lista_planificaciones_eliminadas, setlista_planificaciones_eliminadas] = useState<Array<number>>([])


    useEffect(() => {
        if (anioPlanificacion > 0) {
            setfechainiciomenorrango(new Date(anioPlanificacion, 11, 26))
            setfechafinomenorrango(new Date(anioPlanificacion, 11, 31))
        }
    }, [anioPlanificacion])


    function overlaps_dates(fecha_inicio: Date, fecha_fin: Date, rango_fechas_escogidas: Array<Date>) {
        var arreglo_fechas: Array<Date> = obtener_rango_fechas_no_weekend(new Date(fecha_inicio), new Date(fecha_fin));
        var fechas: Array<Date> = rango_fechas_escogidas;
        var interseccion: Array<Date> = fechas.filter((fecha, index, array) => {
            var indice_encontrado = arreglo_fechas.findIndex((fecha_quitar) => { return fecha.getTime() == fecha_quitar.getTime() });
            return indice_encontrado != -1
        })
        if (interseccion.length !== 0) return true;
        return false;

    }






    function compare_calendario(a: Calendario_Vacaciones, b: Calendario_Vacaciones) {
        if (a.Orden < b.Orden) {
            return -1;
        }
        if (a.Orden > b.Orden) {
            return 1;
        }
        return 0;
    }

    function ObtenerListadoDeFechasCompletasDeCalendario(calendario_vacaciones: Calendario_Vacaciones[]) {
        var fechasPlanificadas: Date[] = [];

        for (let index = 0; index < calendario_vacaciones.length; index++) {
            const element = calendario_vacaciones[index];
            const fechasCalendario = element.Rows
            if (fechasCalendario) {
                for (let index2 = 0; index2 < fechasCalendario.length; index2++) {
                    const element2 = fechasCalendario[index2];
                    const fdesde = new Date(element2.Fechadesde);
                    const fhasta = new Date(element2.Fechahasta);
                    const fechasDeRango = obtener_rango_fechas_no_weekend(fdesde, fhasta)
                    fechasPlanificadas = [...fechasPlanificadas, ...fechasDeRango]
                }

            }

        }

        return fechasPlanificadas;

    }

    function CalendarioTieneFechasPlanificadas(calendario_vacaciones: Calendario_Vacaciones[]) {
        return calendario_vacaciones.find(cv => cv.Rows && cv.Rows.length > 0) !== undefined;
    }

    function ValidarSePlanificanFechasDePeriodos(listadoFechasPeriodo: Date[], calendario_vacaciones: Calendario_Vacaciones[], diasdisponibles: number) {

        var planificaFechasDePeriodos: boolean = false;
        if (listadoFechasPeriodo.length > 0 && diasdisponibles > 0) {
            const fechasPlanificadas: Date[] = ObtenerListadoDeFechasCompletasDeCalendario(calendario_vacaciones);
            var planificaFechasDePeriodos = listadoFechasPeriodo.every(date1 =>
                fechasPlanificadas.some(date2 => date1.getTime() === date2.getTime())
            );

        }
        else {
            planificaFechasDePeriodos = true;
        }

        return planificaFechasDePeriodos

    }
    function ValidarSePlanificanFechasDiferentesDelPeriodo(listadoFechasPeriodo: Date[], calendario_vacaciones: Calendario_Vacaciones[]) {

        var tieneFechasDiferentesDelPeriodo: boolean = false;
        if (listadoFechasPeriodo.length > 0) {
            const fechasPlanificadas: Date[] = ObtenerListadoDeFechasCompletasDeCalendario(calendario_vacaciones);
            tieneFechasDiferentesDelPeriodo = fechasPlanificadas.some(date2 =>
                !listadoFechasPeriodo.some(date1 => date1.getTime() === date2.getTime())
            );

        }


        return tieneFechasDiferentesDelPeriodo

    }

    function compare_Rows_calendario(a: Rows_calendario, b: Rows_calendario) {
        var fecha_a = new Date(a.Fechadesde)
        var fecha_b = new Date(b.Fechadesde)
        if (fecha_a.getTime() < fecha_b.getTime()) {
            return -1;
        }
        if (fecha_a.getTime() > fecha_b.getTime()) {
            return 1;
        }
        return 0;
    }


    function obtener_rango_fechas_no_weekend(inicial: Date, final: Date) {

        var rango_escogido: Array<Date> = [];
        var fecha_inicial = inicial
        rango_escogido.push(fecha_inicial)
        var diferencia_en_tiempo = final.getTime() - inicial.getTime();

        var diferencia_en_dias = diferencia_en_tiempo / (1000 * 3600 * 24);
        for (let index = 0; index < diferencia_en_dias; index++) {
            fecha_inicial = addDays(fecha_inicial, 1)
            if (fecha_inicial.getDay() !== 0 && fecha_inicial.getDay() !== 6) rango_escogido.push(fecha_inicial);

        }

        return rango_escogido;

    }


    function editar_card(datos: Rows_calendario, index_calendario: number, index_row: number): void {
        setfechadesde(datos.Fechadesde);
        setfechahasta(datos.Fechahasta);
        setvaloresModificar({ indice_row: index_row, indice_calendario: index_calendario });
    }

    function ShowModalPeriodos() {
        // const mensajeHTML = `<div class="stylesModalPeriodosPlanifVac"> De acuerdo a <span class="planifvacacioneresolucionperiodo">las Resoluciones del Consejo Politécnico Nros. 22-11-429,  24-10-424,  de 24/11/2022 y 10/10/2024 
        //             respectivamente, y, con base al  calendario académico institucional,  </span>
        //             Ud. debe priorizar la planificación de vacaciones en los 2 periodos siguientes, si su saldo de vacaciones lo permite. Si su saldo es menor, deberá planificar el saldo que tenga disponible a la fecha de corte.  
        //             Recuerde planificar en rangos de 5 días en adelante, dentro del primer período.
        //             </div>
        //             <br/>
        //             <div class="planifvacacionefechasperiodo">
        //                 17/02/2025 al 18/03/2025 y 26/12/2025 al 31/12/2025
        //             </div>
        //             <br/>
        //             <div class="stylesModalPeriodosPlanifVac">
        //                 Posterior a estos períodos y si aún posee saldo para planificar, puede hacerlo en otras fechas
        //              </div>
        //             `
        // showAlertHTMLSwal(mensajeHTML, false);

        // const mensajeHTML = `<div class="stylesModalPeriodosPlanifVac"> En cumplimiento a <span class="planifvacacioneresolucionperiodo">las Resoluciones del Consejo Politécnico Nros. 22-11-429,  24-10-424, </span>
        //             Usted debe priorizar sus vacaciones institucionales en los siguientes períodos:
        //             </div>
        //             <br/>
        //             <div class="planifvacacionefechasperiodo">
        //                 17/02/2025 al 18/03/2025 y 26/12/2025 al 31/12/2025
        //             </div>
        //             <br/>
        //             <div class="stylesModalPeriodosPlanifVac">
        //                 Si su saldo es menor, deberá planificar el disponible a la fecha corte. Si su saldo es mayor Usted podrá adicionar otras fechas.
        //              </div>
        //             `

        const mensajeHTML = (
            <div style={{ textAlign: "center" }}>
                <img
                    className = {"containerBanner"}
                    src={PLANIFICACION} alt="comunicadoMarcacion"></img>
            </div>
    
        )


        setmostrarModalIndicaciones({contenidoModal:mensajeHTML})

        // Swal.fire({
        //     html: mensajeHTML,
        //     //imageUrl: `${AnuncioSVG}`,
        //     //imageHeight: 100, // Ajusta el tamaño según sea necesario
        //     //imageAlt: "Anuncio",
        //     confirmButtonText: "Entendido",
        //     confirmButtonColor: "#243165",

        // });
    }

    function ShowModalDiasAPlanificar(mensaje: string) {

        const mensajeHTML = `<div class="stylesModalPeriodosPlanifVac">  
        ${mensaje}
        </div>`

        // Swal.fire({
        //     html: mensajeHTML,
        //     imageUrl: `${AnuncioSVG}`,
        //     imageHeight: 100, // Ajusta el tamaño según sea necesario
        //     imageAlt: "Anuncio",
        //     confirmButtonText: "Entendido",
        //     confirmButtonColor: "#243165",
        // });

        setmostrarModalIndicaciones({contenidoModal:mensajeHTML})

    }

    function cambiar_valores_eliminar(datos: Rows_calendario, index_calendario: number, index_row: number) {

        const copiaCalendario = [...calendario_vacaciones];
        var copiaDatosMes = { ...calendario_vacaciones[index_calendario] }

        const rowsCalendario: Rows_calendario[] | undefined = copiaDatosMes.Rows?.filter(r => new Date(r.Fechadesde).getTime() !== new Date(datos.Fechadesde).getTime());
        copiaDatosMes.Rows = rowsCalendario;
        copiaCalendario[index_calendario] = copiaDatosMes;

        //const planificavacacionesDelPeriodo = ValidarSePlanificanFechasDePeriodos(listadoFechasPeriodo, copiaCalendario, diasdisponibles);
        //const planificaVacacionesDiferentesDelPeriodo = ValidarSePlanificanFechasDiferentesDelPeriodo(listadoFechasPeriodo, copiaCalendario);
        //if (!planificavacacionesDelPeriodo && planificaVacacionesDiferentesDelPeriodo) {
        //    ShowModalPeriodos();
        //    return;
        //}

        setvaloresEliminar({
            datos_row: datos,
            indice_row: index_row,
            indice_calendario: index_calendario
        })
    }


    useEffect(() => {
        if (valoresEliminar.indice_row !== -1) {

            const { datos_row, indice_row, indice_calendario } = valoresEliminar;
            eliminar_row(datos_row, indice_calendario, indice_row);
        }
    }, [valoresEliminar.indice_row])

    function eliminar_row(datos: Rows_calendario, index_calendario: number, index_row: number) {

        var modificacion_calendario = calendario_vacaciones;
        var rows_modificar = modificacion_calendario[index_calendario].Rows;

        var nuevos_rows: Array<Rows_calendario> = [];
        if (rows_modificar) {
            rows_modificar.map((rows_planificacion, index_rows_planificacion) => {
                if (index_rows_planificacion !== index_row) nuevos_rows.push(rows_planificacion);

            })
        }

        var arreglo_dias_escogidos: Array<Date> = [...fechas_escogidas]
        var arreglos_dias_a_quitar = obtener_rango_fechas_no_weekend(new Date(datos.Fechadesde), new Date(datos.Fechahasta));


        var nuevo_arreglo_dias_escogidos: Array<Date> = arreglo_dias_escogidos.filter((fecha, index, array) => {
            var indice_encontrado = arreglos_dias_a_quitar.findIndex((fecha_quitar) => { return fecha.getTime() == fecha_quitar.getTime() });
            return indice_encontrado == -1
        })


        if (nuevos_rows.length === 0) {
            modificacion_calendario[index_calendario].Show = false;
            if (modificacion_calendario.length === 1) setisCardEmpty(true);
        }
        modificacion_calendario[index_calendario].Rows = nuevos_rows;

        var indice_rechazado = -1;
        indice_rechazado = modificacion_calendario.findIndex((calendario_modificado) => {
            var indice_busco = -1;
            if (calendario_modificado.Rows) {
                indice_busco = calendario_modificado.Rows?.findIndex((rows_calendario_modificado) => {
                    return rows_calendario_modificado.estado === ESTADO_RECHAZADO
                })
            }
            return indice_busco !== -1;
        })
        if (indice_rechazado == -1) { setexisteObservacion(false) }

        var cards_modificadas: any = function_generar_cards(modificacion_calendario, true)
        setCalendario_vacaciones(modificacion_calendario);
        setcards_meses(cards_modificadas);
        setfechas_escogidas(nuevo_arreglo_dias_escogidos);



        //Dias
        var nuevos_dias_planificados = diasplanificados - datos.Dias_solicitados;
        var nuevos_dias_disponibles = diasdisponibles + datos.Dias_solicitados;
        setdiasplanificados(nuevos_dias_planificados);
        setdiasdisponibles(nuevos_dias_disponibles);
        if (nuevos_dias_disponibles <= maximodiasposibles) {
            seterrorPlanificacion(false)
        }
        cambiar_valores_eliminar({ Dias_solicitados: -1, Fechadesde: new Date(), Fechahasta: new Date() }, -1, -1);

        //Agregar a lista de planificaciones eliminadas
        if (datos.idplanificacion !== undefined && datos.idplanificacion !== 0) {
            setlista_planificaciones_eliminadas([...lista_planificaciones_eliminadas, datos.idplanificacion])
        }

    }



    const function_generar_cards = (arregloCalendario: Array<Calendario_Vacaciones>, formatoISO: boolean = false): any => {

        const auxiliar_conocer_estado = (estado: string | undefined) => {
            var estado_parse = "";
            if (estado) {
                switch (estado) {
                    case ESTADO_PENDIENTE:
                        estado_parse = "Pendiente de aprobar por ";
                        break

                    case ESTADO_APROBADO:
                        estado_parse = "Aprobado por "
                        break

                    case ESTADO_RECHAZADO:
                        estado_parse = "No Aprobada por "
                        break

                    default:
                        break
                }
            }

            return estado_parse;
        }

        const generar_footer = (datos_footer: Calendario_Vacaciones): JSX.Element => {
            var banderita_rechazado = false;
            var banderita_aprobado = false;
            var banderita_pendiente = false;
            var estado_general: undefined | string = "";
            if (datos_footer.Rows) {
                datos_footer.Rows.map((valores_rows) => {
                    if (valores_rows.estado === ESTADO_RECHAZADO) banderita_rechazado = true;
                    if (valores_rows.estado === ESTADO_APROBADO) banderita_aprobado = true;
                    if (valores_rows.estado === ESTADO_PENDIENTE) banderita_pendiente = true;

                })

                if (banderita_rechazado) estado_general = ESTADO_RECHAZADO
                else if (banderita_aprobado) estado_general = ESTADO_APROBADO
                else if (banderita_pendiente) estado_general = ESTADO_PENDIENTE
            }
            var estado_parse = auxiliar_conocer_estado(estado_general);

            return (
                <React.Fragment>
                    {/* {estado_general === ESTADO_RECHAZADO && 
                    <div className="observacion_rechazo"> {textoObservacionUsuario}</div>
                    } */}

                    {/* <div className="nombre_estado_footer">Estado:</div>
                    {

                    }
                    {
                        estado_general && datos_footer.Persona_Regula &&
                        <div className="texto_estado">{estado_parse + function_capitalize(datos_footer.Persona_Regula.toLowerCase())}</div>

                    }
                    {
                        estado_general && !datos_footer.Persona_Regula &&
                        <div className="texto_estado">{estado_parse + "su directivo"}</div>

                    } */}


                </React.Fragment>
            )


        }

        const generar_acciones = (datos: Rows_calendario, datos_calendario: Calendario_Vacaciones, index_calendario: number, index_row: number): JSX.Element => {
            return (
                <React.Fragment>
                    {/* {
                        (datos.estado !== ESTADO_PENDIENTE && datos.estado !== ESTADO_APROBADO) && <i onClick={() => editar_card(datos, index_calendario, index_row)} className="fas fa-edit opcion_editar_card"></i>
                    } */}
                    {datos.estado !== ESTADO_APROBACION_PARCIAL && datos.estado !== ESTADO_PENDIENTE && datos.estado !== ESTADO_APROBADO && datos.estado !== ESTADO_ENVIADO_TALENTO_HUMANO &&
                        <i onClick={() => { cambiar_valores_eliminar(datos, index_calendario, index_row) }}


                            className="far fa-times-circle opcion_eliminar_card"></i>
                    }
                    {/* <Container>
                        <Row className="justify-content-end">
                            <Col xl={1}
                            >
                                {
                                    (datos.Estado !== ESTADO_PENDIENTE && datos.Estado !== ESTADO_APROBADO) && <i onClick={()=> editar_card(datos)} className="fas fa-edit opcion_editar_card"></i>
                                }
                            </Col>

                            <Col xl={1} className="mr-2"
                            >
                                {datos.Estado !== ESTADO_PENDIENTE && datos.Estado !== ESTADO_APROBADO &&
                                    <i className="far fa-times-circle opcion_eliminar_card"></i>
                                }

                            </Col>
                        </Row>
                    </Container> */}
                </React.Fragment>
            )
        }

        const generar_icon_segun_estado = (estado: string | undefined): JSX.Element => {
            if (estado) {

                var estado_unificado: string = estado.trim().toUpperCase();
                if (estado_unificado === ESTADO_GUARDADO) {
                    return <div>GUARDADO</div>
                }
                var clase_icono = ""

                switch (estado_unificado) {
                    case ESTADO_PENDIENTE:
                        // clase_icono = "far fa-check-circle icono_aprobado"
                        clase_icono = "PENDIENTE"
                        break;
                    case ESTADO_APROBADO:
                        // clase_icono = "far fa-check-circle icono_aprobado"
                        clase_icono = "APROBADO"
                        break;
                    case ESTADO_RECHAZADO:
                        // clase_icono = "far fa-times-circle icono_rechazado"
                        clase_icono = "RECHAZADO"
                        break;
                    case ESTADO_APROBACION_PARCIAL:
                        // clase_icono = "far fa-times-circle icono_rechazado"
                        clase_icono = "APROBADO PARCIALMENTE"
                        break;
                    case ESTADO_ENVIADO_TALENTO_HUMANO:
                        // clase_icono = "far fa-times-circle icono_rechazado"
                        clase_icono = "ENVIADO A TALENTO HUMANO"
                        break;
                    default:
                        break;
                }
                // return <i className={clase_icono}></i>;
                return <div
                    data-toggle="tooltip"
                    data-placement="top"
                    title={clase_icono}
                    className={"estadoPlanificacionVacUsuario"}
                >
                    {clase_icono}
                </div>

            }

            return <div></div>

        }

        const cards: any = arregloCalendario.map((calendario, index_calendario) => {
            if (calendario.Show) {
                return (
                    <Col className="mb-5" xl={4} lg={6} md={12} key={calendario.Mes + index_calendario} >
                        <Card className="card_planificacion_vacaciones">

                            <CardTitle className="card_header_vacaciones"  >
                                <div className="circle_header" style={{ background: `${calendario.Color}` }} >
                                    <div className="anio_number">{calendario.Anio}</div>
                                </div>
                                <div className="container_text_card_header_vacaciones">
                                    <span>
                                        {calendario.Mes}                        </span>
                                </div>
                            </CardTitle>
                            <CardBody>
                                <Table responsive bordered className="table_planificacion_vacaciones" >
                                    <thead className="cabeceras_tabla_planificacion_vac">
                                        <tr className="borde_cabeceras_planificacion">
                                            <th> Fechas </th>
                                            {/* <th>Desde</th>
                                            <th>Hasta</th> */}
                                            <th style={{ width: "43px" }}>Días</th>
                                            <th>Estado</th>
                                            <th>Acciones</th>
                                        </tr>

                                    </thead>
                                    <tbody>
                                        {calendario.Rows?.map((fila, index_row) => {

                                            // var finicial = formatoISO ? formatoFecha(new Date(fila.Fechadesde).toISOString()) : new Date(fila.Fechadesde).toLocaleString("en-GB", {
                                            //     timeZone: 'America/Bogota',
                                            //     day: "2-digit",
                                            //     month: "2-digit",
                                            //     year: "numeric"
                                            // })

                                            // var ffinal = formatoISO ? formatoFecha(new Date(fila.Fechahasta).toISOString()) : new Date(fila.Fechahasta).toLocaleString("en-GB", {
                                            //     timeZone: 'America/Bogota',
                                            //     day: "2-digit",
                                            //     month: "2-digit",
                                            //     year: "numeric"
                                            // })
                                            



                                            var finicial = ObtenerFechaFromIsoFormat(fila.Fechadesde.toString())
                                            var ffinal = ObtenerFechaFromIsoFormat(fila.Fechahasta.toString())

                                            
                                            if(typeof(fila.Fechadesde) !== "string"){

                                                const formattedDate = fila.Fechadesde.toLocaleDateString('es-ES', {
                                                    day: '2-digit',
                                                    month: '2-digit',
                                                    year: 'numeric',
                                                  });

                                                finicial = formattedDate; 
                                            }

                                            if(typeof(fila.Fechahasta) !== "string"){

                                                const formattedDate = fila.Fechahasta.toLocaleDateString('es-ES', {
                                                    day: '2-digit',
                                                    month: '2-digit',
                                                    year: 'numeric',
                                                  });

                                                  ffinal = formattedDate; 
                                            }
                                            


                                            var options: Intl.DateTimeFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };

                                            // var finicial = new Date(fila.Fechadesde).toLocaleString("es",options).split(" ")[0];

                                            // var ffinal = new Date(fila.Fechahasta).toLocaleString("es",options).split(" ")[0];



                                            // var finicial = fila.Fechadesde.toLocaleDateString("es",options);
                                            // var ffinal = fila.Fechahasta.toLocaleDateString("es",options);
                                            // var finicial =  new Date(fila.Fechadesde.toString().replace(/-/g, '\/').replace(/T.+/, '')).toLocaleString("es",options)
                                            // var ffinal =  new Date(fila.Fechahasta.toString().replace(/-/g, '\/').replace(/T.+/, '')).toLocaleString("es",options)


                                            return (
                                                <tr key={"row" + calendario.Mes + index_row} className="rows_tabla_planificacion_vac">
                                                    <td>
                                                        <div>
                                                            {finicial}
                                                        </div>
                                                        <div>
                                                            {ffinal}
                                                        </div>
                                                    </td>
                                                    {/* <td > 

                                                        {finicial}
                                                    </td>
                                                    <td>
                                                        {ffinal}
                                                    </td> */}

                                                    <td >{fila.Dias_solicitados}</td>
                                                    <td className="fila_icono">{generar_icon_segun_estado(fila.estado)}</td>
                                                    <td>{generar_acciones(fila, calendario, index_calendario, index_row)}</td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>

                                </Table>
                            </CardBody>
                            <CardFooter>
                                {calendario.Estado && generar_footer(calendario)}
                                {/* {calendario.Estado === ESTADO_RECHAZADO && textoObservacionUsuario !== "" && te} */}




                            </CardFooter>

                        </Card>
                    </Col>
                )
            }

        })
        return cards
    }


    const function_generar_tabla_historial: any = (historial_planificacion: Array<Historial_Planificacion>) => {
        const tabla_historial: any = (
            <Table id="table_historial_planificacion">
                <thead >
                    <tr>
                        <th>Año</th>
                        <th>Meses</th>
                        {/* <th>Días Pendientes</th> */}
                        <th>Días Planificados Ordinarios</th>
                        <th>Aprobado por</th>
                    </tr>
                </thead>
                <tbody>
                    {historial_planificacion.map((historial, index) => {
                        return (
                            <tr key={"row_historial" + index}>
                                <td>{historial.key}</td>
                                <td>{historial.value.meses_anio.map((numero_mes, index) => {
                                    return <div key={"meses_row_historial" + index}>
                                        {function_parse_calendario(+numero_mes - 1, false)[0]} <br />
                                    </div>;
                                })}</td>
                                {/* <td>momento xd</td> */}
                                <td>{historial.value.dias_planificados}</td>
                                <td>{historial.value.persona_aprueba}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </Table>

        )
        return tabla_historial;
    }


    const function_validar_request = (error: any): number => {
        if (error.response) {
            return error.response.status
        }
        return 0;
    }

    const Obtener_informacion_planificacion = async () => {
        var currentUser: UserData = authenticationService.currentUserValue;
        var regimen_usuario: Array<number> = currentUser.regimen_usuario

        if (!expresion_civil(regimen_usuario))
            settieneVacaciones(true)

        var restriccion = false;

        if (regimen_usuario.length == 1 && function_obtener_regimen_segun_id(regimen_usuario[0]) === "CIVIL")
            restriccion = true

        settieneRestriccion(restriccion)




        try {
            const respuesta_planificacion = await axios.get(configData.SERVER_URL + `PlanificacionVacaciones/${currentUser?.idpersona}`,
                {
                    headers: {
                        Authorization: `KEYESPOL ${currentUser?.token}`
                    }
                });

            var datos_planificacion: Respuesta_Planificacion_Usuario = respuesta_planificacion.data;

            setanioPlanificacion(datos_planificacion.anio_planificacion)

            setfechaCorteSaldo(datos_planificacion.fechaCorteSaldo.toString());

            var fechasParaPlanificarPorPeriodo: Date[] = []

            for (let index = 0; index < datos_planificacion.periodosParaPlanificar.length; index++) {
                const periodo = datos_planificacion.periodosParaPlanificar[index];
                const fechaDesde = new Date(periodo.fechadesde);
                const fechaHasta = new Date(periodo.fechahasta);

                const rangofechas = obtener_rango_fechas_no_weekend(fechaDesde, fechaHasta);

                fechasParaPlanificarPorPeriodo = [...fechasParaPlanificarPorPeriodo, ...rangofechas]
            }

            if (fechasParaPlanificarPorPeriodo.length > 0) {
                setlistadoFechasPeriodo(fechasParaPlanificarPorPeriodo);
            }


            setmin_fechadesde(new Date(datos_planificacion.anio_planificacion, 0, 1))
            setmax_fechadesde(new Date(datos_planificacion.anio_planificacion, 0, 1))
            var calendario_actual: Array<Calendario_Vacaciones> = []

            setdiaspendientes(datos_planificacion.dias_pendientes.toString() + " días ordinarios");
            setdiaspendientesnumber(datos_planificacion.dias_pendientes);


            if (!datos_planificacion.puedePlanificar) {
                setvalidacionPlanificacion({
                    puedePlanificar: false,
                    motivo: datos_planificacion.motivo
                })
                return
            }

            setplanificaComoDocente(datos_planificacion.planificaComoDocente);



            var puede_planificar: boolean = true;

            var acumulador_dias_planificados = 0;

            var arreglo_fechas_excluidas: Array<Date> = [];

            var contador_fechas_aprobadas = 0

            datos_planificacion.listado_planificacion.map((planificaciones, index) => {
                var estado_card = "NoN";
                var indice_mes_busco = -1;
                acumulador_dias_planificados += planificaciones.dias_solicitados;
                if (planificaciones.estado === ESTADO_ENVIADO_TALENTO_HUMANO) puede_planificar = false;
                // if (planificaciones.estado === ESTADO_PENDIENTE) puede_planificar = false;
                if (planificaciones.estado === ESTADO_APROBADO) contador_fechas_aprobadas++;

                var indice_mes_inicio: number = + formatoFecha(planificaciones.fechainicio.toString()).split("/")[1] - 1
                var Anio = formatoFecha(planificaciones.fechainicio.toString()).split("/")[2];

                //Fechas que se excluyen del date pciker

                var diferencia_dias: Array<Date> = obtener_rango_fechas_no_weekend(new Date(planificaciones.fechainicio), new Date(planificaciones.fechafin));
                arreglo_fechas_excluidas = arreglo_fechas_excluidas.concat(diferencia_dias);
                //Obtener color y mes
                var [nombre_mes, color_mes] = function_parse_calendario(indice_mes_inicio, false)

                //Verificar si alguna planificacion tiene observacion
                if (planificaciones.estado === ESTADO_RECHAZADO && planificaciones.observacion) {

                    settextoObservacionUsuario(planificaciones.observacion);
                    setexisteObservacion(true);
                }


                calendario_actual.map((planif_actual, index) => {
                    if (planif_actual.Mes === nombre_mes) indice_mes_busco = index;
                })

                if (indice_mes_busco != -1) {
                    calendario_actual[indice_mes_busco].Rows?.push(
                        {
                            Fechadesde: planificaciones.fechainicio,
                            Fechahasta: planificaciones.fechafin,
                            Dias_solicitados: planificaciones.dias_solicitados,
                            estado: planificaciones.estado,
                            idplanificacion: planificaciones.idplanificacion ? planificaciones.idplanificacion : 0
                        }
                    )
                }
                else {
                    calendario_actual.push(
                        {
                            Mes: nombre_mes,
                            Orden: indice_mes_inicio + 1,
                            Anio,
                            Color: color_mes,
                            Estado: planificaciones.estado,
                            // Persona_Regula: planificaciones.directivounidad,
                            Show: true,
                            Rows: [{
                                Fechadesde: planificaciones.fechainicio,
                                Fechahasta: planificaciones.fechafin,
                                Dias_solicitados: planificaciones.dias_solicitados,
                                estado: planificaciones.estado,
                                idplanificacion: planificaciones.idplanificacion ? planificaciones.idplanificacion : 0
                            }]

                        }
                    )
                }

            })

            //Actualizar informacion de calendario y de historial
            setCalendario_vacaciones(calendario_actual);
            settable_historial_planificacion(function_generar_tabla_historial(datos_planificacion.historial_planificacion))

            //Actualizar arreglo de fechas que se han escogido

            var array_feriados: Array<Date> = []
            datos_planificacion.feriados.map((fechas_feriados) => {
                array_feriados.push(new Date(fechas_feriados));
            })

            arreglo_fechas_excluidas = [...arreglo_fechas_excluidas]
            setfechas_escogidas(arreglo_fechas_excluidas);
            setfechas_feriados(array_feriados);
            //Calculo de dias
            var dias_pendientes_usuario: number = datos_planificacion.dias_pendientes;
            var regimen_texto = ""
            var bandera_tiene_LOES = false;
            var bandera_tiene_LOSEP = false;
            var bandera_tiene_CODIGO = false;
            if (regimen_usuario.length > 1) {
                //Se supone que no puedo tener regimen LOSEP y codigo de trabajo al mismo tiempo
                regimen_usuario.map((valores_regimen) => {
                    var nombre_regimen: string = function_obtener_regimen_segun_id(valores_regimen);
                    if (nombre_regimen === "LOSEP") {
                        bandera_tiene_LOSEP = true
                    }
                    else if (nombre_regimen === "CÓDIGO DE TRABAJO") {
                        bandera_tiene_CODIGO = true
                    }
                    else if (nombre_regimen === "LOES") {
                        bandera_tiene_LOES = true
                    }
                })


                if (bandera_tiene_LOES && bandera_tiene_LOSEP) regimen_texto = "LOSEP"
                else if (bandera_tiene_CODIGO && bandera_tiene_LOES) regimen_texto = "CÓDIGO DE TRABAJO"
                else if (bandera_tiene_LOES) regimen_texto = "LOES"
                else if (bandera_tiene_LOSEP) regimen_texto = "LOSEP"


            }
            else if (regimen_usuario.length == 1) {
                regimen_texto = function_obtener_regimen_segun_id(regimen_usuario[0])

            }

            setdiasplanificados(acumulador_dias_planificados);
            if (acumulador_dias_planificados !== 0) {
                setdiasdisponibles(datos_planificacion.dias_pendientes - acumulador_dias_planificados)
            }
            else {
                setdiasdisponibles(dias_pendientes_usuario)
            }
            // else if (datos_planificacion.dias_pendientes < diasdisponibles) {
            //     setdiasdisponibles(dias_pendientes_usuario)
            //     // setmaximodiasposibles(datos_planificacion.dias_pendientes)
            // }

            var dias_minimos: number = 0;


            setregimentexto(regimen_texto);

            if (regimen_texto === "LOSEP" || regimen_texto === "LOES") {
                if (dias_pendientes_usuario >= 22) {
                    setminimosdiasposibles(22);
                    dias_minimos = 22;
                } else {
                    setminimosdiasposibles(dias_pendientes_usuario);
                }
            }
            else if (regimen_texto === "CÓDIGO DE TRABAJO") {
                setmaximodiasposibles(22)
                if (dias_pendientes_usuario >= 11) {
                    setminimosdiasposibles(11);
                    dias_minimos = 11;
                } else {
                    setminimosdiasposibles(dias_pendientes_usuario)
                }
            }

            if (dias_minimos === 0) { dias_minimos = dias_pendientes_usuario }


            const mensajeRecordatorio = `Según su régimen laboral ${regimen_texto}, `
            setrecordatoriodiasminimo(mensajeRecordatorio);

            const listadoPlanificaciones = datos_planificacion.listado_planificacion;
            const cantidadPlanificaciones = listadoPlanificaciones.length;
            var cantidadEnviadaATH = 0;
            var cantidadRechazadas = 0;
            var cantidadGuardadas = 0;
            if (listadoPlanificaciones.length > 0) {
                const planifEnviadasTH = listadoPlanificaciones.filter(lp => lp.estado && lp.estado.trim() === ESTADO_ENVIADO_TALENTO_HUMANO);
                const planifRechazadas = listadoPlanificaciones.filter(lp => lp.estado && lp.estado.trim() === ESTADO_RECHAZADO);
                const planifGuardadas = listadoPlanificaciones.filter(lp => lp.estado && lp.estado.trim() === ESTADO_GUARDADO);
                cantidadEnviadaATH = planifEnviadasTH !== undefined ? planifEnviadasTH.length : 0;
                cantidadRechazadas = planifRechazadas !== undefined ? planifRechazadas.length : 0;
                cantidadGuardadas = planifGuardadas !== undefined ? planifGuardadas.length : 0;
            }

            if (cantidadRechazadas > 0 && cantidadEnviadaATH > 0) {
                puede_planificar = true;
            }

            var tiene_todo_aprobado = datos_planificacion.listado_planificacion.length == 0 ? false : datos_planificacion.listado_planificacion.length === contador_fechas_aprobadas
            setestatodoAprobado(tiene_todo_aprobado);
            puede_planificar = puede_planificar && (!tiene_todo_aprobado || acumulador_dias_planificados < dias_minimos)
            setpuedeEnviarPlanificacion(puede_planificar);

            if (regimen_texto === "LOES") {

                if (!CalendarioTieneFechasPlanificadas(calendario_actual)) {
                    ShowModalPeriodos();
                }

            }
            else {
                const mensajediasMinimosPlanificar = MensajeDiasMinimosPlanificar(regimen_texto, mensajeRecordatorio)
                ShowModalDiasAPlanificar(mensajediasMinimosPlanificar)
            }


        } catch (error) {
            var mensaje = "Ha ocurrido un inconveniente";
            if (axios.isAxiosError(error) && error.response && error.response.status === 409) {
                mensaje = error.response.data;
            }
            var error_any: any = error;
            var status = handle_error(error_any);
            switch (status) {
                case 500:
                    alertService.error("Ha ocurrido un inconveniente")
                    break;
                case 409:
                    alertService.error(mensaje)
                    break;
                case 0:
                    alertService.error("No se ha podido contactar con el servidor intente más tarde")
                    break;
                default:
                    break;
            }
        }

        setloading(false);
    }


    useEffect(() => {
        Obtener_informacion_planificacion();
    }, [])


    useEffect(() => {
        if (calendario_vacaciones.length != 0) {
            const cards: any = function_generar_cards(calendario_vacaciones);
            setcards_meses(cards);

        }
    }, [calendario_vacaciones])


    const handleValormes = (fd: Date | undefined, fh: Date | undefined) => {

        


        if (fd != undefined && fh != undefined) {
            var indice_mes_inicio: number = +formatoFechaTimeZoneLocal(fd).split("/")[1] - 1;
            var fecha_formato: number = +formatoFechaTimeZoneLocal(fd).split("/")[1] - 1;

            if (mes === fecha_formato) {
                fecha_formato += 0.1;
            }

            return fecha_formato;
        }
        return -1;
    }


    const auxiliar_handleClick = (mes: number, dias_pendientes_local: number, dias_solicitados_local: number) => {
        var new_calendario_state: Array<Calendario_Vacaciones> = calendario_vacaciones;
        var [nombre_mes, color_mes] = function_parse_calendario(mes, false);
        var year = formatoFecha(fechadesde?.toISOString()).split("/")[2];
        var indice_mes_busco = -1;

        calendario_vacaciones.map((planificacion, index) => {
            if (planificacion.Mes.toLowerCase() === nombre_mes.toLowerCase()) indice_mes_busco = index
        })

        if (indice_mes_busco !== -1 && fechadesde != undefined && fechahasta != undefined) {
            var valor_dias_planificados = function_calcular_dias_ordinarios(new Date(fechadesde), new Date(fechahasta))






            new_calendario_state[indice_mes_busco].Rows?.push({
                Fechadesde: fechadesde,
                Fechahasta: fechahasta,
                Dias_solicitados: valor_dias_planificados
            })

            new_calendario_state[indice_mes_busco].Rows?.sort((a, b) => compare_Rows_calendario(a, b))

            new_calendario_state[indice_mes_busco].Show = true;


        }
        else if (indice_mes_busco === -1 && fechadesde != undefined && fechahasta != undefined) {
            var valor_dias_planificados = function_calcular_dias_ordinarios(new Date(fechadesde), new Date(fechahasta))



            new_calendario_state.push({
                Mes: nombre_mes,
                Orden: mes + 1,
                Color: color_mes,
                Anio: year,
                Show: true,
                Rows: [{
                    Fechadesde: fechadesde,
                    Fechahasta: fechahasta,
                    Dias_solicitados: valor_dias_planificados
                }]
            })
        }

        new_calendario_state.sort((a, b) => compare_calendario(a, b));

        var cards: any = function_generar_cards(new_calendario_state, false)
        setCalendario_vacaciones(new_calendario_state)

        //Modificar valores que se pueden elegir
        if (fechadesde && fechahasta) {
            var nuevas_fechas_escogidas = obtener_rango_fechas_no_weekend(fechadesde, fechahasta);
            // var rango_escogido: Array<Date> = fechas_escogidas;
            // var fecha_inicial = fechadesde
            // rango_escogido.push(fecha_inicial)
            // var diferencia_en_tiempo = fechahasta.getTime() - fechadesde.getTime();

            // var diferencia_en_dias = diferencia_en_tiempo / (1000 * 3600 * 24);
            // for (let index = 0; index < diferencia_en_dias; index++) {
            //     fecha_inicial = addDays(fecha_inicial, 1)
            //     if (fecha_inicial.getDay() !== 0 && fecha_inicial.getDay() !== 6) rango_escogido.push(fecha_inicial);

            // }
            setfechas_escogidas([...fechas_escogidas, ...nuevas_fechas_escogidas]);
        }



        setfechadesde(undefined);
        setfechahasta(undefined);
        setdiassolicitados("");
        setcards_meses(cards);
        seterrorPlanificacion(false)
        seterrorOverlapFecha(false)

        //dias
        var nuevo_planificado = diasplanificados + dias_solicitados_local;
        var nuevo_disponible = diasdisponibles - dias_solicitados_local;
        //Si la nueva cantidad planificada es superior o igual a la minima se quita la advertencia
        if (nuevo_planificado >= minimosdiasposibles) {
            var indice_error = erroresGenerales.indexOf(ERROR_NO_ALCANZA_DIAS_MINIMOS);
            if (indice_error !== -1) {
                var nuevos_errores_generales: Array<string> = [...erroresGenerales];
                nuevos_errores_generales.splice(indice_error, 1)
                seterroresGenerales([...nuevos_errores_generales])
            }

        }



        setdiasplanificados(nuevo_planificado);
        setdiasdisponibles(nuevo_disponible);
        //Al ingresar aunque sea algo nuevo, puede enviar la planificacion
        setpuedeEnviarPlanificacion(true);
        setisCardEmpty(false);


    }

    const auxiliarhandleClickEditar = (mes: number) => {
        var new_calendario_state: Array<Calendario_Vacaciones> = calendario_vacaciones;
        var bandera_error = false;
        // var bandera_overlaps = false;
        if (valoresModificar.indice_calendario !== -1 && fechadesde != undefined && fechahasta != undefined) {
            var valor_dias_planificados = function_calcular_dias_ordinarios(new Date(fechadesde), new Date(fechahasta))



            var indice_modificar: number = valoresModificar.indice_row;
            var row_planificado_anterior: Array<Rows_calendario> | undefined = new_calendario_state[valoresModificar.indice_calendario].Rows;
            var dias_planificado_anterior = 0
            if (row_planificado_anterior) {
                dias_planificado_anterior = row_planificado_anterior[indice_modificar].Dias_solicitados;
                row_planificado_anterior[indice_modificar] = { Fechadesde: fechadesde, Fechahasta: fechahasta, Dias_solicitados: valor_dias_planificados }

            }

            var diferencia_dias_edicion = dias_planificado_anterior - valor_dias_planificados


            var displanificados_sin_anterior = diasplanificados - dias_planificado_anterior;
            var nuevos_dias_planificados = displanificados_sin_anterior + valor_dias_planificados
            var nuevos_dias_disponibles = (diasdisponibles + dias_planificado_anterior) - valor_dias_planificados;
            if (nuevos_dias_planificados > maximodiasposibles) bandera_error = true



            if (!bandera_error) {
                new_calendario_state[valoresModificar.indice_calendario].Rows?.sort((a, b) => compare_Rows_calendario(a, b))
                setdiasplanificados(nuevos_dias_planificados);
                setdiasdisponibles(nuevos_dias_disponibles);
            }

        }

        if (bandera_error) {
            seterrorPlanificacion(true)
            const mensajeErrorPlanificacion = `No puede exceder la cantidad de días que tiene pendientes o la cantidad de días permitidos por año ( hasta  ${maximodiasposibles} días ordinarios)`
            showAlertSwal(mensajeErrorPlanificacion, false)


        }
        // else if (bandera_overlaps) seterrorPlanificacion(true)
        else {
            new_calendario_state.sort((a, b) => compare_calendario(a, b));
            var cards: any = function_generar_cards(new_calendario_state, true)
            setCalendario_vacaciones(new_calendario_state)
            if (fechadesde && fechahasta) {
                var rango_escogido: Array<Date> = fechas_escogidas;
                var fecha_inicial = fechadesde
                rango_escogido.push(fecha_inicial)
                var diferencia_en_tiempo = new Date(fechahasta).getTime() - new Date(fechadesde).getTime();

                var diferencia_en_dias = diferencia_en_tiempo / (1000 * 3600 * 24);
                for (let index = 0; index < diferencia_en_dias; index++) {
                    fecha_inicial = addDays(fecha_inicial, 1)
                    if (fecha_inicial.getDay() !== 0 && fecha_inicial.getDay() !== 6) rango_escogido.push(fecha_inicial);

                }
                setfechas_escogidas(rango_escogido);

            }

            setfechadesde(undefined);
            setfechahasta(undefined);
            setdiassolicitados("");
            setcards_meses(cards);
            seterrorPlanificacion(false)
            seterrorOverlapFecha(false)
        }

        setvaloresModificar({ indice_row: -1, indice_calendario: -1 });
    }







    const handleClick = (mes: number) => {

        var dias_solicitados_local: number = + diassolicitados.split(" ")[0];
        var dias_pendientes_local: number = + diaspendientes.split(" ")[0];
        var bandera_overlaps = false;
        if (fechadesde && fechahasta) bandera_overlaps = overlaps_dates(fechadesde, fechahasta, fechas_escogidas);

        if (valoresModificar.indice_row !== -1) {
            if (bandera_overlaps) {
                seterrorOverlapFecha(true)
                const mensajeErrorOverlap = "No puede elegir un rango de fechas que interfiera con otro escogido anteriormente"
                showAlertSwal(mensajeErrorOverlap, false)
            }
            else auxiliarhandleClickEditar(mes)


        }
        else {
            if (dias_solicitados_local > diasdisponibles || diasplanificados + dias_solicitados_local > maximodiasposibles) {
                seterrorPlanificacion(true)
                const mensajeErrorPlanificacion = `No puede exceder la cantidad de días que tiene pendientes o la cantidad de días permitidos por año ( hasta  ${maximodiasposibles} días ordinarios)`
                showAlertSwal(mensajeErrorPlanificacion, false)
            }
            else if (bandera_overlaps) {
                const mensajeErrorOverlap = "No puede elegir un rango de fechas que interfiera con otro escogido anteriormente"
                showAlertSwal(mensajeErrorOverlap, false)
                seterrorOverlapFecha(true);
            }
            else auxiliar_handleClick(mes, dias_pendientes_local, dias_solicitados_local);
        }

    }





    useEffect(() => {
        var value_mes: number = -1;
        /* HACK PARA ENTENDER EL VALOR DEL INDICE DEL MES A CAMBIAR, 
        SI EL VALOR VIENE CON DECIMAL, SE LE RESTA 0.1, ES DECIR    1.1 - 0.1 = 1 Y ESE ES EL VALOR 
        DEL MES A EDITAR  */
        if (mes !== -1 && mes <= 11) {
            value_mes = mes;
            if (value_mes % 1 != 0) {
                if (value_mes == 0.1) value_mes = 0;
                else if (value_mes == 1.1) value_mes = 1;
                else if (value_mes == 2.1) value_mes = 2;
                else if (value_mes == 3.1) value_mes = 3;
                else if (value_mes == 4.1) value_mes = 4;
                else if (value_mes == 5.1) value_mes = 5;
                else if (value_mes == 6.1) value_mes = 6;
                else if (value_mes == 7.1) value_mes = 7;
                else if (value_mes == 8.1) value_mes = 8;
                else if (value_mes == 9.1) value_mes = 9;
                else if (value_mes == 10.1) value_mes = 10;
                else if (value_mes == 11.1) value_mes = 11;

            }
            handleClick(value_mes);
        }

    }, [mes])



    const handleFechadesde = (e: any) => {
        
        setfechadesde(e)
        setfechahasta(undefined)
    }

    const handleFechahasta = (e: any) => {
        
        setfechahasta(e)
    }

    useEffect(() => {
        if (fechadesde != undefined && fechahasta != undefined) {

            var cantidadMinima = CANTIDAD_DIAS_DEBE_PLANIFICARSE_POR_RANGO;
            if (diaspendientesnumber < CANTIDAD_DIAS_DEBE_PLANIFICARSE_POR_RANGO) {
                cantidadMinima = diaspendientesnumber;
            }

            const contador_dias_ordinarios = function_calcular_dias_ordinarios(new Date(fechadesde), new Date(fechahasta));
            setdiassolicitados(`${contador_dias_ordinarios.toString()} días ordinarios`);


            const enRangoFechasPermitidas = CompareRangeBetweenDates(fechadesde, fechahasta, fechainiciomenorrango, fechafinmenorrango);

            if (contador_dias_ordinarios < cantidadMinima && !enRangoFechasPermitidas) {
                setdisabledButtonPlanificar(true)
                setshowWarningDias(true)
                const textoWarning = `<div style="text-align: justify;">
                Para planificar vacaciones debe hacerlo en un <strong>rango igual o mayor a  ${CANTIDAD_DIAS_DEBE_PLANIFICARSE_POR_RANGO} días </strong>.
                </div>
                <br/>
                <div style="text-align: justify;">
                Ud. Puede planificar una cantidad menor a  ${CANTIDAD_DIAS_DEBE_PLANIFICARSE_POR_RANGO} días si escoge desde el <strong>26 al 31 de diciembre</strong>
                </div>
                `

                showAlertHTMLSwal(textoWarning, false)


            }
            else {
                setdisabledButtonPlanificar(false);
                setshowWarningDias(false)

            }


        }
        else {
            setdisabledButtonPlanificar(true);
        }
    }, [fechadesde, fechahasta, fechainiciomenorrango, fechafinmenorrango, diaspendientesnumber,planificaComoDocente])

    useEffect(() => {



        if (erroresGenerales.length !== 0 && valoresEliminar.indice_row !== -1) {
            var indice_error = erroresGenerales.indexOf(ERROR_ENVIO_PLANIFICACION_RECHAZADA);
            if (indice_error !== -1) {
                var nuevos_errores_generales: Array<string> = [...erroresGenerales];
                nuevos_errores_generales.splice(indice_error, 1)
                seterroresGenerales([...nuevos_errores_generales])
            }
        }
    }, [valoresEliminar.indice_row, erroresGenerales.length])




    const handleEnviar = async () => {
        setloadingPost(true);
        var currentUser: UserData = authenticationService.currentUserValue;

        var datos_enviar: Array<Planificacion_Enviar> = [];
        var bandera_enviar = true;

        if (diasplanificados < minimosdiasposibles) {
            seterroresGenerales([...erroresGenerales, ERROR_NO_ALCANZA_DIAS_MINIMOS])
            showAlertSwal(ERROR_NO_ALCANZA_DIAS_MINIMOS, false);
            bandera_enviar = false
        }
        else {
            calendario_vacaciones.map((valores_calendario, index) => {
                valores_calendario.Rows?.map((valores_rows, index) => {
                    if (valores_rows.estado && valores_rows.estado === ESTADO_RECHAZADO) {

                        seterroresGenerales([...erroresGenerales, ERROR_ENVIO_PLANIFICACION_RECHAZADA])
                        showAlertSwal(ERROR_ENVIO_PLANIFICACION_RECHAZADA, false);


                        bandera_enviar = false;
                    }
                    if (valores_rows.estado === undefined || valores_rows.estado === ESTADO_GUARDADO) {
                        datos_enviar.push({
                            fechainicio: parseDatetoFormatSend(valores_rows.Fechadesde),
                            fechafin: parseDatetoFormatSend(valores_rows.Fechahasta),
                            estadoAprobacion: valores_rows.estado
                        })
                        valores_rows.estado = ESTADO_PENDIENTE
                    }

                })

            })
        }


        if (bandera_enviar) {

            try {
                const llamada = await axios.post(configData.SERVER_URL + `PlanificacionVacaciones/${currentUser?.idpersona}`, datos_enviar,
                    {
                        headers: {
                            Authorization: `KEYESPOL ${currentUser?.token}`
                        }
                    })
                showAlertSwal("La planificación ha sido enviada con éxito.", true)
                setactualizarCalendario(true)
                setpuedeEnviarPlanificacion(false);

            } catch (error) {
                var error_any: any = error;
                var status_code: number = handle_error(error_any);
                switch (status_code) {
                    case 400:

                        if (error_any.response !== undefined && error_any.response.data.errors.Planificacion_Vacaciones) {
                            showAlertSwal("El periodo de planificación aún no comienza o ha terminado", false)
                        }
                        else {
                            alertService.error("Error 400");
                        }
                        break;
                    case 409:
                        alertService.error(error_any.response.data);
                        break;
                    default:
                        showAlertSwal("Ha ocurrido un inconveniente", false)
                        break;
                }
            }
            finally {
                window.scrollTo({
                    top: 0,
                    behavior: "auto"
                });
            }

        }
        setloadingPost(false);


    }

    const handleGuardarBorradorPlanificacion = async () => {
        var bandera_enviar = true;
        if (diasplanificados > 0 && diasplanificados < minimosdiasposibles) {
            seterroresGenerales([...erroresGenerales, ERROR_NO_ALCANZA_DIAS_MINIMOS])
            bandera_enviar = false
            showAlertSwal(ERROR_NO_ALCANZA_DIAS_MINIMOS, false);
        }
        else if (diasplanificados === 0) {
            bandera_enviar = false;
        }

        if (bandera_enviar) {
            setloadingPost(true)
            var currentUser: UserData = authenticationService.currentUserValue;
            var planificaciones_borradas = lista_planificaciones_eliminadas;
            var planificacionUsuarioGuardar: Array<Planificacion_Enviar> = [];
            calendario_vacaciones.map((valores_calendario, index) => {
                valores_calendario.Rows?.map((valores_rows, index) => {

                    if (valores_rows.estado === undefined) {

                        var ini = parseDatetoFormatSend(valores_rows.Fechadesde)
                        var fin = parseDatetoFormatSend(valores_rows.Fechahasta)

                        planificacionUsuarioGuardar.push({
                            fechainicio: ini,
                            fechafin: fin,
                            estadoAprobacion: ESTADO_GUARDADO
                        })
                        valores_rows.estado = ESTADO_GUARDADO
                    }

                })

            })

            //Validar fechas de parametros y periodos establecidos
            if (listadoFechasPeriodo.length > 0) {
                const planificaFechasDePeriodos: boolean = ValidarSePlanificanFechasDePeriodos(listadoFechasPeriodo, calendario_vacaciones, diasdisponibles);

                if (!planificaFechasDePeriodos) {
                    ShowModalPeriodos();
                    setloadingPost(false)
                    return;
                }

            }



            var datos_enviar = {
                planificacionUsuarioGuardar,
                planificaciones_borradas
            }




            try {


                const llamada = await axios.post(configData.SERVER_URL + `PlanificacionVacaciones/GuardarBorrador/${currentUser?.idpersona}`, datos_enviar,
                    {
                        headers: {
                            Authorization: `KEYESPOL ${currentUser?.token}`
                        }
                    })
                showAlertSwal("La planificación ha sido guardada con éxito.", true)
                setactualizarCalendario(true)
                window.location.reload();


            } catch (error) {
                var error_any: any = error;
                var status_code: number = handle_error(error_any);
                switch (status_code) {
                    case 400:

                        if (error_any.response.data.errors.Planificacion_Vacaciones) {
                            alertService.error("El periodo de planificación aún no comienza o ha terminado");
                        }
                        else {
                            alertService.error("Error 400");
                        }
                        break;

                    default:
                        alertService.error("Ha ocurrido un inconveniente");
                        break;
                }
            }
            finally {
                window.scrollTo({
                    top: 0,
                    behavior: "auto"
                });
            }
            setloadingPost(false);
        }

    }

    useEffect(() => {
        if (actualizarCalendario) {
            //Colocar a  todas las planificaciones con estado PENDIENTE.
            var copia_calendario_vacaciones_modificada: Array<Calendario_Vacaciones> = calendario_vacaciones;
            // copia_calendario_vacaciones_modificada.map((calendario,index) => {

            //     if(calendario.Rows){
            //         var copiaRows = calendario.Rows;
            //         copiaRows.map((rowscalendario,index) => {
            //             rowscalendario.Fechadesde = ""
            //         })
            //     }
            // })

            // console.log(copia_calendario_vacaciones_modificada, "COPIA CALENDARIO EN ENVIAR ANTES")
            // copia_calendario_vacaciones_modificada.map((calendario_valores) => {
            //     if (calendario_valores.Rows !== undefined) {
            //         calendario_valores.Rows.map((rows) => {
            //             rows.estado = ESTADO_PENDIENTE
            //         })
            //         calendario_valores["Estado"] = ESTADO_PENDIENTE
            //     }
            // })
            // console.log(copia_calendario_vacaciones_modificada, "COPIA CALENDARIO EN ENVIAR DESPUES")

            setCalendario_vacaciones([...copia_calendario_vacaciones_modificada])
            setactualizarCalendario(false);
        }
    }, [actualizarCalendario])

    useEffect(() => {
        if (valoresModificar.indice_row === -1) {
            var arreglo_dias_escogidos: Array<Date> = fechas_escogidas;
            var arreglos_dias_a_quitar: Array<Date> = []

            if (fechadesde && fechahasta) {
                arreglos_dias_a_quitar = obtener_rango_fechas_no_weekend(fechadesde, fechahasta);

            }


            var nuevo_arreglo_dias_escogidos: Array<Date> = arreglo_dias_escogidos.filter((fecha, index, array) => {
                var indice_encontrado = arreglos_dias_a_quitar.findIndex((fecha_quitar) => { return fecha.getTime() == fecha_quitar.getTime() });
                return indice_encontrado == -1
            })
            setmostrarModificar(false);
            setfechas_escogidas(nuevo_arreglo_dias_escogidos);
        }
        else setmostrarModificar(true)
    }, [valoresModificar.indice_row])


    useEffect(() => {
        if (cards_meses.length > 0 && calendario_vacaciones[0].Rows?.length !== 0) {

            setisCardEmpty(false)
        }
        else if (cards_meses.length === 0) setisCardEmpty(true)
    }, [cards_meses])

    useEffect(() => {

        var nrodias = 22;
        if (regimentexto === "LOSEP" || regimentexto === "LOES") {
            nrodias = 22;
        }
        else if (regimentexto === "CÓDIGO DE TRABAJO") {
            nrodias = 11;
        }

        var mensajeAdicionalNroDias = ``
        // if (regimentexto !== "LOES") {
        //     mensajeAdicionalNroDias = `La planificación debe hacerla en un rango igual o mayor a ${CANTIDAD_DIAS_DEBE_PLANIFICARSE_POR_RANGO} días.`
        // }

        mensajeAdicionalNroDias = `La planificación debe hacerla en un rango igual o mayor a ${CANTIDAD_DIAS_DEBE_PLANIFICARSE_POR_RANGO} días.`

        var mensaje = `${recordatoriodiasminimo} usted debe planificar por lo menos ${nrodias} días ordinarios y si su saldo es menor, debe planificar todos esos días pendientes. ${mensajeAdicionalNroDias}`;
        // if (minimosdiasposibles < nrodias) {
        //     mensaje = `${recordatoriodiasminimo} usted debe planificar por lo menos ${minimosdiasposibles} días ordinarios. ${mensajeAdicionalNroDias}`
        // }

        setmensajeDiasMinimos(mensaje);


    }, [regimentexto, minimosdiasposibles, recordatoriodiasminimo])

    function MensajeDiasMinimosPlanificar(regimentexto: string, recordatoriodiasminimo: string) {
        var nrodias = 22;
        if (regimentexto === "LOSEP" || regimentexto === "LOES") {
            nrodias = 22;
        }
        else if (regimentexto === "CÓDIGO DE TRABAJO") {
            nrodias = 11;
        }

        var mensajeAdicionalNroDias = ``


        mensajeAdicionalNroDias = `La planificación debe hacerla en un rango igual o mayor a ${CANTIDAD_DIAS_DEBE_PLANIFICARSE_POR_RANGO} días.`

        var mensaje = `${recordatoriodiasminimo} usted debe planificar por lo menos ${nrodias} días ordinarios y si su saldo es menor, debe planificar todos esos días pendientes. ${mensajeAdicionalNroDias}`;

        return mensaje
    }

    const isFeriado = (date: Date, feriados: Array<Date>) => {
        var time_fecha = date.getTime();
        var indice_fecha: number = feriados.findIndex((fer) => fer.getTime() == time_fecha);
        if (indice_fecha !== -1) {
            return "feriadoDay"
        }
    }

    const isFeriadoFilter = (date: Date, feriados: Array<Date>) => {
        var time_fecha = date.getTime();
        var indice_fecha: number = feriados.findIndex((fer) => fer.getTime() == time_fecha);
        return indice_fecha == -1
    }

    if (!tieneVacaciones) return <div className="content">NO PUEDE REALIZAR ACCIONES EN ESTA SECCIÓN</div>
    if (tieneRestriccion) return <div className="content">LO SENTIMOS, POR EL MOMENTO NO PUEDE PLANIFICAR SUS VACACIONES</div>
    if (!validacionPlanificacion.puedePlanificar) return <div className="content">LO SENTIMOS, NO PUEDE PLANIFICAR VACACIONES PORQUE {validacionPlanificacion.motivo}</div>

    const contenidoMensajeAlerta = (
        <div id="containerAlertDiasElegidosPlanificacion">
            <div > Ud ha planificado <span className="number_alert">{diasplanificados} </span> días ordinarios para el año {anioPlanificacion}</div>
            <div > Le quedan disponibles <span className="number_alert">{diasdisponibles} </span> días ordinarios de sus días de vacaciones pendientes</div>

        </div>
    )

    const toggleModal = () => setmostrarModalIndicaciones(undefined);




    if (loading) return <Cargando />
    return (
        <div className="content">

            {/* <h1>Aqui iria el contenido de vacaciones,</h1>
            <img src="https://i.ytimg.com/vi/BE6ogFlKp6A/sddefault.jpg"></img>

            <h1>Si tuviera el contenido</h1>
            <img src="https://pbs.twimg.com/media/DJ3Dzw7XoAAgQOl.jpg"></img> */}

            <Container fluid={true} id="container_padre_planificacion">
                <Row>
                    <Col xl={12}>
                        <h4>PLANIFICACIÓN DE VACACIONES</h4>

                    </Col>
                </Row>
                <Row className="justify-content-start">
                    {/* <Col xl={12} sm={12}>
                        {
                            planificaComoDocente &&
                            <div id="" className=" alerta_error mb-1">
                                <div className="cabecera_alerta_red">
                                    <img src={Megafono} className="icono_imagen" /> AVISO
                                </div>
                                <div className="cuerpo_alerta">{`Estimado(a), Se recomienda planificar sus vacaciones acorde al periodo vacacional estípulado en el calendario académico institucional. \n En los meses de febrero, marzo y diciembre.`}</div>

                            </div>
                        }
                    </Col> */}

                    {/* <Col xl={12} sm={12} className="mb-2">
                        <AlertNew
                            cabeceraTitulo={"RECUERDE QUE: "}
                            mensaje={''}
                            mensajeHTML={mensajeDiasMinimos}
                            oncloseElement={() => { ; }}
                            tipo={TiposAlerta.PLANIFICACION_VACACIONES}
                        />
                    </Col> */}

                    <Col xl={12} lg={12}>
                        {/* <label>#Días pendientes de vacaciones</label> */}
                        <label> Días ordinarios pendientes de vacaciones: <strong style={{ color: "blue" }}>{diaspendientes} </strong>  <strong>{`(fecha de corte: ${FormatoDiaMesAnioFecha(fechaCorteSaldo)})`}</strong></label>
                        {/* <Input type="text" value={diaspendientes} readOnly id="dias_pendientes_input"></Input> */}
                    </Col>

                </Row>
                {/* <Row>
                    <Col>
                        <strong><i>Su saldo de días pendientes para planificar vacaciones tiene fecha de corte al {FormatoDiaMesFecha(fechaCorteSaldo)} del presente año.</i></strong>

                    </Col>
                </Row> */}
                <Row className={"mt-3 justify-content-start"}>
                    <Col xl={2} lg={3}>
                        <label>Fecha desde</label>
                        {
                            listadoFechasPeriodo.length > 0 && !ValidarSePlanificanFechasDePeriodos(listadoFechasPeriodo, calendario_vacaciones, diasdisponibles) &&
                            <Datepicker
                                value={fechadesde}
                                name="fechadesde"
                                id="fechadesde"
                                onChange={(e) => handleFechadesde(e)}
                                min={min_fechadesde}
                                max={new Date(anioPlanificacion, 11, 31)}
                                filter={(date: Date) => isWeekday(date) && isFeriadoFilter(date, fechas_feriados)}
                                includeDates={listadoFechasPeriodo}
                                showDisabledMonthNavigation={true}
                                disabled={!puedeEnviarPlanificacion}
                                excludeDates={fechas_escogidas}
                                dayClassName={(date: Date) => isFeriado(date, fechas_feriados)}
                                monthdropdown={true}
                            />
                        }
                        {
                            (listadoFechasPeriodo.length === 0 || ValidarSePlanificanFechasDePeriodos(listadoFechasPeriodo, calendario_vacaciones, diasdisponibles))
                            &&
                            <Datepicker
                                value={fechadesde}
                                name="fechadesde"
                                id="fechadesde"
                                onChange={(e) => handleFechadesde(e)}
                                min={min_fechadesde}
                                max={new Date(anioPlanificacion, 11, 31)}
                                filter={(date: Date) => isWeekday(date) && isFeriadoFilter(date, fechas_feriados)}
                                showDisabledMonthNavigation={true}
                                disabled={!puedeEnviarPlanificacion || diasdisponibles <= 0}
                                excludeDates={fechas_escogidas}
                                dayClassName={(date: Date) => isFeriado(date, fechas_feriados)}
                                monthdropdown={true}
                            />
                        }

                    </Col>
                    <Col xl={2} lg={3}>
                        <label>Fecha hasta</label>
                        {
                            listadoFechasPeriodo.length > 0 && !ValidarSePlanificanFechasDePeriodos(listadoFechasPeriodo, calendario_vacaciones, diasdisponibles) &&
                            <Datepicker

                                value={fechahasta}
                                name="fechahasta"
                                id="fechahasta"
                                onChange={(e) => handleFechahasta(e)}
                                min={fechadesde == undefined ? min_fechadesde : fechadesde}
                                max={new Date(anioPlanificacion, 11, 31)}
                                filter={(date: Date) => isWeekday(date) && isFeriadoFilter(date, fechas_feriados)}
                                showDisabledMonthNavigation={true}
                                includeDates={listadoFechasPeriodo}
                                excludeDates={fechas_escogidas}
                                dayClassName={(date: Date) => isFeriado(date, fechas_feriados)}
                                disabled={!puedeEnviarPlanificacion}
                                monthdropdown={true}




                            />
                        }
                        {
                            (listadoFechasPeriodo.length === 0 || ValidarSePlanificanFechasDePeriodos(listadoFechasPeriodo, calendario_vacaciones, diasdisponibles)) &&
                            <Datepicker

                                value={fechahasta}
                                name="fechahasta"
                                id="fechahasta"
                                onChange={(e) => handleFechahasta(e)}
                                min={fechadesde == undefined ? min_fechadesde : fechadesde}
                                max={new Date(anioPlanificacion, 11, 31)}
                                filter={(date: Date) => isWeekday(date) && isFeriadoFilter(date, fechas_feriados)}
                                showDisabledMonthNavigation={true}
                                excludeDates={fechas_escogidas}
                                dayClassName={(date: Date) => isFeriado(date, fechas_feriados)}
                                disabled={!puedeEnviarPlanificacion || diasdisponibles <= 0}
                                monthdropdown={true}




                            />
                        }

                    </Col>
                    <Col xl={2} lg={3} sm={12}>
                        <label>#Días solicitados</label>
                        <Input id="dias_solicitados_input" type="text" value={diassolicitados} readOnly></Input>
                    </Col>
                    <Col xl={2} lg={3} sm={12} id="col_button_planificar">


                        {puedeEnviarPlanificacion && !mostrarModificar &&
                            <button id="btnPlanificarVacaciones" disabled={disabledButtonPlanificar} onClick={() => setmes(handleValormes(fechadesde ? fechadesde : new Date(), fechahasta ? fechahasta : new Date()))}> <div id={"text_button_planificar"} > Planificar </div></button>
                        }

                        {puedeEnviarPlanificacion && mostrarModificar &&
                            <button onClick={() => { setmes(handleValormes(fechadesde ? fechadesde : new Date(), fechahasta ? fechahasta : new Date())) }} > <div > Modificar </div></button>
                        }

                    </Col>

                </Row>

                {
                    // showWarningDias &&
                    // <>
                    //     <Row>
                    //         <Col>
                    //             <small className='small-error-planificacion'>Para planificar vacaciones debe hacerlo en un rango igual o mayor a  {CANTIDAD_DIAS_DEBE_PLANIFICARSE_POR_RANGO} días</small>

                    //         </Col>
                    //     </Row>
                    //     <Row>
                    //         <Col>
                    //             <small className='small-error-planificacion'>Ud. Puede planificar una cantidad menor a  {CANTIDAD_DIAS_DEBE_PLANIFICARSE_POR_RANGO} días si escoge desde el 26 al 31 de diciembre</small>
                    //         </Col>
                    //     </Row>
                    // </>


                }


                <Row className="mt-3 container-pv-guardar">
                    <Col xl={6} md={12}>



                        {
                            diasplanificados != 0 && !estatodoAprobado && anioPlanificacion !== 0 &&

                            // <div id="alerta_dias_planificados" className="mb-1">
                            //     <div className="cabecera_alerta">
                            //         <img src={Megafono} className="icono_imagen" /> AVISO
                            //     </div>
                            //     {recordatoriodiasminimo !== "" &&
                            //         <div className="cuerpo_alerta_recordatorio"> {`Recordatorio: ${recordatoriodiasminimo} `}
                            //             <span className="recordatorio_resaltar"> Usted debe planificar por lo menos {minimosdiasposibles} día(s) ordinario(s)</span>
                            //         </div>
                            //     }
                            //     <div className="cuerpo_alerta"> Ud ha planificado <span className="number_alert">{diasplanificados} </span> días ordinarios para el año {anioPlanificacion}</div>
                            //     <div className="cuerpo_alerta"> Le quedan disponibles <span className="number_alert">{diasdisponibles} </span> días ordinarios de sus días de vacaciones pendientes</div>

                            // </div>
                            <AlertNew
                                cabeceraTitulo={"AVISO"}
                                mensaje=''
                                mensajeHTML={contenidoMensajeAlerta}
                                oncloseElement={() => { ; }}
                                tipo={TiposAlerta.PLANIFICACION_VACACIONES_AVISO}
                            />
                        }
                        {
                            errorPlanificacion &&
                            <div />
                            // <div id="alerta_error_planificacion" className="alerta_error mb-1">
                            //     {/* <div>Iconos diseñados por <a href="https://www.freepik.com" title="Freepik">Freepik</a> from <a href="https://www.flaticon.es/" title="Flaticon">www.flaticon.es</a></div> */}
                            //     <div className="cabecera_alerta_red">
                            //         <img src={Megafono} className="icono_imagen" /> AVISO
                            //     </div>

                            //     <div className="cuerpo_alerta">{`No puede exceder la cantidad de días que tiene pendientes o la cantidad de días permitidos por año ( hasta  ${maximodiasposibles} días ordinarios)`}</div>


                            // </div>
                        }
                        {
                            errorOverlapFecha &&
                            <div />
                            // <div id="alerta_error_overlap" className="alerta_error mb-1">
                            //     {/* <div>Iconos diseñados por <a href="https://www.freepik.com" title="Freepik">Freepik</a> from <a href="https://www.flaticon.es/" title="Flaticon">www.flaticon.es</a></div> */}
                            //     <div className="cabecera_alerta_red">
                            //         <img src={Megafono} className="icono_imagen" /> AVISO ERROR
                            //     </div>

                            //     <div className="cuerpo_alerta"> No puede elegir un rango de fechas que interfiera con otro escogido anteriormente </div>


                            // </div>

                        }
                        {
                            erroresGenerales.length !== 0 &&
                            <div />
                            // <div className="alerta_error mb-1">
                            //     <div className="cabecera_alerta_red">
                            //         <img src={Megafono} className="icono_imagen" /> AVISO ERRORES
                            //     </div>
                            //     {
                            //         erroresGenerales.map((texto_error, index) => {
                            //             return (
                            //                 <div key={"error_general " + index} className="cuerpo_alerta"> {texto_error} </div>
                            //             )
                            //         })
                            //     }


                            // </div>
                        }
                    </Col>
                    <Col xl={2}>
                        <div id="containerBtnsPlanifVac">
                            {puedeEnviarPlanificacion && CalendarioTieneFechasPlanificadas(calendario_vacaciones) &&
                                <button onClick={() => { handleGuardarBorradorPlanificacion() }} disabled={calendario_vacaciones.length === 0} id="button_guardar_planificacion">
                                    <div className="text_button_enviar">
                                        Guardar
                                    </div>
                                </button>
                            }
                            {!isCardEmpty && puedeEnviarPlanificacion &&
                                <button className="btnEnviarPlanificacion" onClick={() => { handleEnviar() }} id="button_enviar_planificacion">
                                    <div className="text_button_enviar">
                                        Enviar
                                    </div>
                                </button>
                            }
                        </div>
                    </Col>
                    {/* <Col xl={2} md={2} sm={2}>
                        {puedeEnviarPlanificacion && CalendarioTieneFechasPlanificadas(calendario_vacaciones) &&
                            <button onClick={() => { handleGuardarBorradorPlanificacion() }} disabled={calendario_vacaciones.length === 0} id="button_guardar_planificacion">
                                <div className="text_button_enviar">
                                    Guardar
                                </div>
                            </button>
                        }
                    </Col>
                    <Col xl={2} md={2} sm={2} className="text-right">
                        {!isCardEmpty && puedeEnviarPlanificacion &&
                            <button className="btnEnviarPlanificacion" onClick={() => { handleEnviar() }} id="button_enviar_planificacion">
                                <div className="text_button_enviar">
                                    Enviar
                                </div>
                            </button>
                        }
                    </Col> */}
                </Row>
            </Container>


            {loadingPost && <Cargando />}
            {!loadingPost &&
                <Container fluid={true}>
                    <Row className="mt-5">
                        {
                            cards_meses
                        }

                    </Row>
                    <Row className="mt-2">
                        <Col xl={6} md={8} sm={12}>
                            {existeObservacion &&
                                <div className="container_observacion_usuario">
                                    <div>Observaciones Rechazo</div>
                                    <textarea
                                        className="textarea_observacion_usuario"
                                        readOnly
                                        value={textoObservacionUsuario}
                                    />
                                </div>

                            }

                        </Col>


                    </Row>


                </Container>

            }


            <Container fluid={true}>
                <Row className="mt-5">
                    <Col xl={4}>
                        <div onClick={() => setmostrar_table_historial(!mostrar_table_historial)} className="texto_historial">
                            Historial de planificación &gt; &gt;
                        </div>
                    </Col>
                </Row>


                <Row className="mt-3 ">
                    <Col xl={12}>
                        {
                            mostrar_table_historial ? table_historial_planificacion : ""
                        }
                    </Col>
                </Row>
            </Container>

            {/* <ModalConfirmacion
                show = {mostrarModalIndicaciones !== undefined}
                asyncAccion = {false}
                asyncClose = {false}
                closeAfterAccion = {false}
                hideBotonCerrar = {false}
                contentModal={mostrarModalIndicaciones?.contenidoModal}
                mensajeConfirmacion=''
                nombreBotonAccion='Aceptar'
                size='lg'
                onClose={() => setmostrarModalIndicaciones(undefined)}
                centered = {true}
            />   */}
            {/*{*/}
            {/*    mostrarModalIndicaciones !== undefined &&*/}
            {/*    <Modal*/}
            {/*        isOpen={mostrarModalIndicaciones !== undefined}*/}
            {/*        scrollable = {false}*/}
            {/*        size = {"lg"}*/}
            {/*        fullscreen={"lg"}*/}
            {/*        centered={true}*/}
            {/*        toggle = { toggleModal}*/}
            {/*    >*/}
            {/*        <ModalHeader close = {<IconCloseModal handleClickIcon={() => setmostrarModalIndicaciones(undefined)} />}  />*/}
            {/*        <ModalBody>*/}
            {/*            <div className='containerImgPlanif'>*/}
            {/*            <img*/}
            {/*        className = {"modal-image"}*/}
            {/*        src={PLANIFICACION} alt="comunicadoMarcacion"></img>*/}
            {/*            </div>*/}
                    
            {/*        </ModalBody>*/}
            {/*    </Modal>*/}
            {/*}*/}


            {/* <ModalConfirmacion
                show={true}
                asyncAccion={false}
                asyncClose={false}
                closeAfterAccion={false}
                hideBotonCerrar={true}
                size='md'
                centered = {true}
                nombreBotonAccion='Aceptar'
                onClose={() => console.log("")}
                mensajeConfirmacion=''
                contentModal={
                    <React.Fragment>
                        <div className="stylesModalPeriodosPlanifVac"> De acuerdo a <span className="planifvacacioneresolucionperiodo">las Resoluciones del Consejo Politécnico Nros. 22-11-429,  24-10-424,  de 24/11/2022 y 10/10/2024
                            respectivamente, y, con base al  calendario académico institucional,  </span>
                        </div>
                        <div className="stylesModalPeriodosPlanifVac">
                            Ud debe priorizar la planificación de vacaciones en los siguientes períodos, hasta cumplir los 22 días ordinarios o su saldo disponible.
                            Recuerde planificar en rangos de 5 días en adelante, dentro del primer período.
                        </div>
                        <div className="planifvacacionefechasperiodo">
                            17/02/2025 al 18/03/2025 y 26/12/2025 al 31/12/2025
                        </div>
                    </React.Fragment>
                }
                showTituloModal = {false}
            /> */}

        </div>
    )
}
export default PlanificacionVacaciones
